import { create } from "zustand";
import { getUserDetails } from "../../ApiServices/User/userApis";
import {
  SOCKET_OPERATIONS,
  SOCKET_OPERATIONS_ERROR,
  SOCKET_OPERATIONS_SUCCESS,
} from "../../services/socketoOperations";
import { useStoryCoinHelper } from "../../components/StoryCoin/storyCoinHook";
import socketStore from "../SocketStore";
import { subscriptionStore } from "../SubscriptionStore";
import toast from "react-hot-toast";
import characterStore from "../CharactersStore";
import api from "../../composables/app";
import { API } from "../../ApiServices/apis";
import { signOut } from "firebase/auth";
import Cookies from "js-cookie";
import { auth } from "../../components/Config/config";
import { update } from "lodash";

const useUserDetailsStore = create((set, get) => ({
  isOnline: true,
  setIsOnline: (isOnline) => set({ isOnline }),
  pageVisibility: true,
  setPageVisibility: (pageVisibility) => {
    const socketState = socketStore.getState();
    const { userSocket, storySocket } = socketState;
    const now = Date.now();

    if (pageVisibility) {
      if (userSocket) {
        userSocket.startConnectionChecker(now);
      }
      if (storySocket) {
        storySocket.startConnectionChecker(now);
      }
    } else {
      if (userSocket) {
        userSocket.stopConnectionChecker();
      }
      if (storySocket) {
        storySocket.stopConnectionChecker();
      }
    }
    set({ pageVisibility });
  },
  creditSocket: null,
  userDetail: null,
  credit: 0,
  canAddHuman: true,
  canAddBook: true,
  canAddCharacter: true,
  updateCanAddHuman: (canAddHuman) => set({ canAddHuman }),
  updateCanAddBook: (canAddBook) => set({ canAddBook }),
  updateCanAddCharacter: (canAddCharacter) => {
    set({ canAddCharacter });
  },
  fixedLength: true,
  imagePredictionStatus: null,
  setCredits: (credits) => set({ credits }),
  fetchUserDetail: async () => {
    const setDontShowConfirmation =
      useStoryCoinHelper.getState().setDontShowConfirmation;
    try {
      const response = await getUserDetails();
      set({
        userDetail: response.data.data,
        credit: response.data.data.user.credit,
        canAddHuman: response.data.data.actions.can_add_human,
        canAddBook: response.data.data.actions.can_add_book,
        canAddCharacter: response.data.data.actions.can_add_character,
        fixedLength: response.data.data.actions.is_fixed_length,
      });
      localStorage.setItem("u_d", response?.data?.data?.user?.id);
      setDontShowConfirmation(!response.data.data.user.show_credit_dialog);
      get().initailizeCreditSocket(response.data.data.user.id);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  },
  initailizeCreditSocket: (userId) => {
    const socketSt = socketStore.getState();
    const roomId = `user_${userId}`;
    socketSt.initializeUserSocket(roomId, [
      function userSocketCallback(message) {
        switch (message.op) {
          case SOCKET_OPERATIONS.USER_CREDIT_BALANCE:
            set({ credit: message.data.credit });
            break;
          case SOCKET_OPERATIONS.SUBSCRIPTION_STATUS_CHANGE:
            var subscriptionState = subscriptionStore.getState();
            subscriptionState.fetchActiveSubscription();
            useUserDetailsStore.getState().fetchUserDetail();
            toast.success("Subscription status changed successfully");
            if (window.location.pathname.includes("/payment-success")) {
              window.location.href = "/stories";
            }
            break;
          case SOCKET_OPERATIONS.HUMAN_IMAGE_PREDICTION:
            if (message.data?.status_code === 1000) {
              characterStore
                .getState()
                .updateHumanImagePredictionPendingStatus(true);
              toast(message.data.status_message);
            } else if (message.data?.status_code === 1) {
              characterStore
                .getState()
                .updateHumanImagePredictionPendingStatus(false);
            } else {
              characterStore
                .getState()
                .updateHumanImagePredictionPendingStatus(true);
              toast.error(
                message.data?.status_message || "Human image prediction failed"
              );
            }
            break;

          case SOCKET_OPERATIONS_SUCCESS.CHARACTER_AVATAR_GENERATION_SUCCESS:
            characterStore.getState().updateCharacterAvatar(message.data);
            break;
          case SOCKET_OPERATIONS_ERROR.CHARACTER_AVATAR_GENERATION_FAILURE:
            if (message.failure_reason === "content_policy_violation") {
              toast.error(
                "Failed to generate character avatar. Content policy violation detected."
              );
              characterStore.getState().updateCharacterAvatar(message.data);

              return;
            }
            toast.error("Character avatar generation failed");

            break;

          default:
            break;
        }
      },
    ]);
  },
  deleting: false,
  deleteAccount: () => {
    // delete account
    set({ deleting: true });
    api
      .delete(API.user.deleteAccount)
      .then((response) => {
        if (response.status === 200) {
          Cookies.remove("story_token");
          localStorage.removeItem("u_d");
          signOut(auth);
          window.location.href = "/login";
        }
      })
      .finally(() => {
        set({ deleting: false });
      });
  },
}));

export default useUserDetailsStore;
